//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data () {
		return {
			activeIndex: 0,
			list: [],
			isNameError: false,
			isPhoneError: false,
			isContextError:false,
			form: {
				publishId: '',
				contactName: '',
				phoneNum: '',
				type: '',
				context: ''
			}
		}
	},
	components: {},
	onLoad () {
		this.init()
	},
	methods: {
		contactName(e){
			this.form.contactName=e.target.value
			this.isNameError = this.testName(this.form.contactName)
		},
		phoneNum(e){
			this.form.phoneNum=e.target.value
			this.isPhoneError = this.testPhone(this.form.phoneNum)
		},
		context(e){
			this.form.context=e.target.value
			this.isContextError = !this.testContext(this.form.context)
		},
		//客服
		tel(){
			uni.makePhoneCall({
				phoneNumber: this.$store.state.serviceTel
			})
		},
		testName () {
			return /^[\u4E00-\u9FA5A-Za-z]+$/.test(this.form.contactName)
		},
		testContext () {
		    return /[`~!@#\$%\^\&\*\(\)_\+<>\?:"\{\},\.\\\/;'\[\]]/im.test(this.form.context)
		},
		testPhone () {
			return /^1[345789]\d{9}$/.test(this.form.phoneNum)
		},
		//获取字典投诉建议标签
		init () {
			this.$ajax({
				method: 'post',
				url: '/weChat/dictionary/queryChildrenByParentCode',
				data: {
					code: 'COMPLAIN_TYPE',
					isEnable: 1
				}
			}).then(res=>{
				this.list = res.data
				this.form.type = this.list[0].code
			})
		},
		back () {
			uni.navigateBack({
				delta:1
			})
		},
		//保存
		save () {
			let flag = true
			this.form.publishId = this.$store.state.userInfo.memberId
			if(!this.isContextError){
				uni.showToast({
					title:'请填写正确的描述内容',
					icon:'none'
				})
			} else {
				uni.showToast({
					title:'提交中...',
					icon:"loading",
					mask:true
				})
				if (flag) {
					this.$ajax({
						method: 'post',
						url: '/weChat/cms/complaint/add',
						data: this.form
					}).then(res=>{
							uni.showToast({
								icon:'none',
								title:'提交成功！'
							})
							uni.navigateTo({
								url:'./succeed'
							})
					})
				} else {
					uni.showToast({
						icon:'none',
						title:'请填写完整~'
					})
				}
			}
		},
		change (code, i) {
			this.form.type = code
			this.activeIndex = i
		}
	}
}
